





















































































import { mdiHeadset, mdiAccountMultiple, mdiPhone, mdiAlert } from "@mdi/js";
import { Component, Mixins } from "vue-property-decorator";
import LanguageChanger from "@/components/utility/LanguageChanger.vue";
import IconItem from "@/components/ui/IconItem.vue";
import { LinkMixin } from "@/mixins/LinkMixin";
import RatingDialog from "./AppRating.vue";
import QuestionnaireDialog from "./AppQuestionnaire.vue";
import PayInstruction from "../Auth/PayInstruction.vue";
import SignActInstruction from "../Auth/SignActInstruction.vue";

@Component({
  components: {
    LanguageChanger,
    IconItem,
    RatingDialog,
    QuestionnaireDialog,
    PayInstruction,
    SignActInstruction,
  },
})
export default class AppHeader extends Mixins(LinkMixin) {
  mdiHeadset = mdiHeadset;
  mdiAccountMultiple = mdiAccountMultiple;
  mdiPhone = mdiPhone;
  mdiAlert = mdiAlert;

  // instagramSvg = require("@/assets/insta.svg");
  // facebookSvg = require("@/assets/facebook.svg");
  // telegramSvg = require("@/assets/telegram.svg");
  get logoMaxWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case "sm":
      case "md":
      case "lg":
      case "xl":
        return "250px";
      case "xs":
      default:
        return "180px";
    }
  }
}
